"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichSelector = void 0;
// eslint-disable-next-line import/prefer-default-export
const enrichSelector = ({ enrich }) => enrich;
exports.enrichSelector = enrichSelector;
